export const games = {
    yx: 'Permainan',
    yxms: 'Semua keputusan hasil dalam permainan kripto telah dibuat sebelumnya dalam bentuk hash, tidak akan diubah oleh keinginan siapa pun, menjamin keadilan dan kejujuran mutlak!',
    mnsm: 'Coba Simulasi',
    ljqw: 'Main Sekarang',
    loading: 'Sedang memuat, harap tunggu',
    dyh: 'Beragam kontrak opsi tersedia untuk Anda, keuntungan hingga ratusan kali lipat, ROI tinggi dalam jangka pendek',
    qyhy: 'Kontrak Opsi',
    qsyhys: 'Opsi',
    kd: 'Buat Order',
    qt: 'Taruhan Menarik',
    ljjy: "Berdagang Sekarang",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/ba.js